import { toast } from "react-toastify";
import { useMutation } from "@apollo/client/react";
import {
  FetchTenderByIdDocument,
  RequestMarginDecisionOnGroupMutation,
  RequestMarginDecisionOnGroupMutationVariables,
  RequestMarginDecisionOnGroupDocument,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";

/**
 * Custom hook for requesting margin approval and handling the necessary cache updates.
 * @returns {Object} - Contains the requestMarginDecisionlMutation function, loading state, and error state.
 */
export default function useRequestMarginDecisionOnGroupMutationHook(): {
  requestMarginDecisionOnGroupMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{
    tenderID: string;
    marginDecisionGroupID: string;
  }>();

  const [requestMarginDecisionOnGroupMutation, { loading, error }] = useMutation<RequestMarginDecisionOnGroupMutation, RequestMarginDecisionOnGroupMutationVariables>(
    RequestMarginDecisionOnGroupDocument, {
      onCompleted: () => {
        toast(CustomToastComponent, {
          toastId: "margin-decision-requested-group-success",
          data: {
            title: t("toasts.approvalrequestsent"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: FetchTenderByIdDocument,
          variables: { id: Number(tenderID) },
        },
      ],
    });

  return {
    requestMarginDecisionOnGroupMutation,
    loading,
    error,
  };
}
